export default {
  // Options.jsx
  items_per_page: '/ stronę',
  label_items_per_page: 'Items / page',
  jump_to: 'Idź do',
  jump_to_confirm: 'potwierdzać',
  page: '',

  // Pagination.jsx
  first_page: 'First Page',
  last_page: 'Last Page',
  prev_page: 'Poprzednia strona',
  next_page: 'Następna strona',
  prev_5: 'Poprzednie 5 stron',
  next_5: 'Następne 5 stron',
  prev_3: 'Poprzednie 3 strony',
  next_3: 'Następne 3 strony',
};
